import React, { useState } from "react";
import ModalBasic from "../../components/ModalBasic.jsx";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton, SecondaryButton } from "../../components/Buttons.jsx";
import { addToast } from "../../store/app/action.js";
import { setupAccount, updateMerchantUser } from "../../api/index.js";
import { isValidInput } from "../../utils/Utils.js";
import PasswordStrengthIndicator from "../../components/PasswordStrengthIndicator.jsx";

function ChangePasswordModal() {
  const { changePasswordModalOpen, user } = useSelector((state) => state.app);
  const [loading, setLoading] = React.useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordOk, setPasswordOk] = useState(false);
  const dispatch = useDispatch();
  const submit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      existing_password: formData.get("existingPassword"),
      new_password: formData.get("newPassword"),
      confirm_password: formData.get("confirmPassword"),
      first_name: formData.get("firstName"),
      last_name: formData.get("lastName"),
    };
    if (data.new_password !== data.confirm_password) {
      dispatch(
        addToast({ type: "error", message: "Passwords do not match", timer: 5 })
      );
      return;
    }

    if (changePasswordModalOpen === "init") {
      if (!data.first_name || !data.last_name) {
        dispatch(
          addToast({
            type: "error",
            message: "First Name and Last Name are required",
            timer: 5,
          })
        );
        return;
      }
      try {
        setLoading(true);
        await setupAccount(data);
        dispatch(
          addToast({
            type: "success",
            message: "Account setup successfully",
            timer: 5,
          })
        );
        dispatch({ type: "SET_CHANGE_PASSWORD_MODAL_OPEN", payload: false });
      } catch (e) {
        dispatch(
          addToast({
            type: "error",
            message:
              "Error setting up account, please contact support at direct-merchant@saucey.com",
            timer: 5,
          })
        );
      } finally {
        setLoading(false);
      }
    } else {
      // Change password logic
      setLoading(true);
      try {
        const result = await updateMerchantUser({
          current_password: data.existing_password,
          new_password: data.new_password,
        });
        dispatch(
          addToast({
            type: "success",
            message: "Password changed successfully",
            timer: 5,
          })
        );
        dispatch({ type: "SET_CHANGE_PASSWORD_MODAL_OPEN", payload: false });
      } catch (e) {
        let message = "please try again";
        try {
          const serverMessage = e.response?.data?.error;
          if (serverMessage) {
            message = serverMessage;
          }
        } catch {}

        dispatch(
          addToast({
            type: "error",
            message: "Error changing password: " + message,
            timer: 5,
          })
        );
      }
      setLoading(false);
    }
  };
  return (
    <ModalBasic
      title={
        changePasswordModalOpen === "init" ? "Account Setup" : "Change Password"
      }
      hideCloseButton={true}
      description="Enter your new password and confirm it."
      buttonClass="btn btn-primary"
      buttonDataToggle="modal"
      buttonDataTarget="#changePasswordModal"
      buttonDataBackdrop="static"
      buttonDataKeyboard="false"
      modalOpen={
        changePasswordModalOpen === "init" || changePasswordModalOpen === true
      }
      width="sm"
    >
      <form onSubmit={submit}>
        {changePasswordModalOpen !== "init" ? (
          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-1"
              htmlFor="Existing Password"
            >
              Existing Password
            </label>
            <div className="flex gap-1 items-center">
              <input
                autoComplete="current-password"
                className="form-input w-96"
                type="password"
                placeholder="Enter existing Password"
                name="existingPassword"
              />
            </div>
          </div>
        ) : (
          <>
            <div className="mb-4">
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="lastName"
              >
                First Name
              </label>
              <div className="flex gap-1 items-center">
                <input
                  className="form-input w-96"
                  type="text"
                  placeholder="Enter First Name"
                  name="firstName"
                  defaultValue={user?.first_name || ""}
                />
              </div>
            </div>
            <div className="mb-4">
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="Last Name"
              >
                Last Name
              </label>
              <div className="flex gap-1 items-center">
                <input
                  className="form-input w-96"
                  type="text"
                  placeholder="Enter Last Name"
                  name="lastName"
                  defaultValue={user?.last_name || ""}
                />
              </div>
            </div>
          </>
        )}
        <div className="mb-4">
          <label
            className="block text-sm font-medium mb-1"
            htmlFor="New Password"
          >
            New Password
          </label>
          <div className="flex gap-1 items-center">
            <input
              className="form-input w-96"
              type="password"
              placeholder="Enter new Password"
              name="newPassword"
              value={newPassword}
              autoComplete="new-password"
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
        </div>
        <div className="mb-4">
          <label
            className="block text-sm font-medium mb-1"
            htmlFor="Confirm Password"
          >
            Confirm Password
          </label>
          <div className="flex gap-1 items-center">
            <input
              className="form-input w-96"
              type="password"
              placeholder="Confirm new Password"
              name="confirmPassword"
              value={confirmPassword}
              autoComplete="new-password"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <PasswordStrengthIndicator
            password={newPassword}
            confirmPassword={confirmPassword}
            className="mt-3"
            setPasswordOk={setPasswordOk}
          />
        </div>
        <div className={"flex gap-2"}>
          {changePasswordModalOpen !== "init" && (
            <SecondaryButton
              loading={loading}
              onClick={(e) => {
                e.preventDefault();
                dispatch({
                  type: "SET_CHANGE_PASSWORD_MODAL_OPEN",
                  payload: false,
                });
              }}
            >
              Cancel
            </SecondaryButton>
          )}
          <PrimaryButton type="submit" loading={loading} disabled={!passwordOk}>
            {changePasswordModalOpen === "init"
              ? "Complete Setup"
              : "Change Password"}
          </PrimaryButton>
        </div>
      </form>
    </ModalBasic>
  );
}

export default ChangePasswordModal;
